module.exports = __webpack_public_path__ + "img/Image - Header 5(5).060d4f08.png";